<p-overlayPanel #op class="p-overlaypanel">
  <ng-template pTemplate>
    <div class="p-5">
      <div class="text-lg font-normal mb-3">
        Send install link to email or mobile number
      </div>
      <form [formGroup]="installForm" (ngSubmit)="onSubmit(op)" class="pt-5">
        <div class="flex flex-column gap-3">
          <div class="field">
            <div class="flex align-items-center">
              <label for="fullName" class="block mb-0 w-4 text-right pr-2 form-lable">Full Name</label>
              <div class="p-inputgroup custom-height w-full">
                <input 
                  id="fullName"
                  pInputText 
                  type="text"
                  formControlName="fullName"
                  class="custom-input"
                  placeholder="Enter full name"/>
              </div>
            </div>
          </div>

          <div class="field">
            <div class="flex align-items-center">
              <label for="phone" class="block mb-0 w-4 text-right pr-2 form-lable">Phone #</label>
              <div class="flex w-full mobile-input">
                <div (click)="country.toggle($event)" class="custom-input w-auto px-2 pointer flag-selection">
                  <img [src]="selectedCountry.phone.flag" alt="flag" width="18" height="18">
                </div>
                <p-overlayPanel #country styleClass="overlay-nav">
                  <ul class="p-0 m-0 list-none" (click)="country.hide()">
                    <li *ngFor="let i of countries" 
                        class="pointer text-sm px-5 py-2 color-primary" 
                        (click)="onCountrySelect(i, $event)">
                      {{ i.label }}
                    </li>
                  </ul>
                </p-overlayPanel>
                <div class="w-full">
                  <p-inputMask 
                    id="phone"
                    mask="(999)-999-9999" 
                    styleClass="custom-input number-input" 
                    formControlName="phone"
                    placeholder="(000) 000-0000" 
                    [unmask]="true">
                  </p-inputMask>
                </div>
              </div>
            </div>
          </div>

          <div class="field">
            <div class="flex align-items-center">
              <label for="email" class="block mb-0 w-4 text-right pr-2 form-lable">Email</label>
              <div class="p-inputgroup custom-height w-full">
                <input 
                  id="email"
                  pInputText 
                  type="email"
                  formControlName="email"
                  class="custom-input"
                  placeholder="Enter email"/>
              </div>
            </div>
          </div>
        </div>
        <div class="flex justify-content-end gap-2 mt-4">
          <p-button 
            label="Dismiss" 
            styleClass="custom-button custom-secondary" 
            (onClick)="onDismiss(op)">
          </p-button>
         <p-button 
            [label]="isSending ? 'Sending...' : 'Send'"
            styleClass="custom-button custom-primary"
            type="submit"
            [disabled]="!installForm.valid || isSending">
          </p-button>
        </div>
      </form>
    </div>
  </ng-template>
</p-overlayPanel>

<p-toast></p-toast> 